import { createFileRoute, Link } from '@tanstack/react-router'
import { GuideArticle, GuideSection } from '~/components/guide/GuideArticle'

export const Route = createFileRoute('/guide/getting-started')({
  component: GettingStarted,
})

function GettingStarted() {
  return (
    <GuideArticle>
      <GuideSection title="Welcome">
        <p>
          This is a full-stack starter: a pnpm monorepo with a TanStack Start
          web app, a Drizzle/Postgres data layer, a REST API, and an MCP server
          — all deployed to ECS/Fargate behind a shared ALB + CloudFront.
        </p>
        <p>
          It ships with authentication (Keycloak OIDC + personal access tokens)
          and role-based access control already wired through every layer. There
          is no example domain entity — the <code>users</code> and{' '}
          <code>roles</code> features <em>are</em> the worked reference.
        </p>
      </GuideSection>

      <GuideSection title="Finding your way around">
        <ul className="list-disc space-y-1 pl-5">
          <li><Link to="/admin/users" className="underline underline-offset-2">Admin → Users &amp; Roles</Link> — manage who can do what.</li>
          <li><Link to="/admin/api-keys" className="underline underline-offset-2">Admin → API Keys</Link> — mint application tokens scoped to any of the permissions a role can hold.</li>
          <li><Link to="/settings" className="underline underline-offset-2">Settings</Link> — manage your personal access tokens, plus the developer references below.</li>
          <li><Link to="/openapi" className="underline underline-offset-2">API reference</Link> — the live OpenAPI document for <code>/api/v1</code> (under Settings → Developer Options).</li>
          <li><Link to="/mcp-instructions" className="underline underline-offset-2">MCP</Link> — connect an AI agent to the same API surface (under Settings → Developer Options).</li>
        </ul>
      </GuideSection>

      <GuideSection title="Where to go next">
        <p>
          Read{' '}
          <Link to="/guide/concepts" className="underline underline-offset-2">Architecture &amp; Concepts</Link>{' '}
          to understand the package layout and how to add your own entity through
          every layer.
        </p>
      </GuideSection>
    </GuideArticle>
  )
}
